/**
 * For maintainability we should separate controllers into their own modules
 */

angular.module('acme.view.application.dataGrid.controllers', [
  'ui.grid',
  'ui.grid.selection',
  'ui.grid.pagination',
  'ui.grid.resizeColumns',
  'ui.grid.edit',
  'ui.grid.grouping',
  'ui.grid.draggable-rows',
  'ui.grid.moveColumns',
  'ui.grid.saveState',
  'ui.grid.cellNav',
  'ui.grid.exporter',
  'agGrid',
  'angularUUID2'
])

.controller('DataGridController', ['$scope', '$parse', '$timeout', '$filter', '$q', '$attrs', 'uuid2', function($scope, $parse, $timeout, $filter, $q, $attrs, uuid2) {

  var ctrl = {

    resizeGridTimer: false,
    resizeAGGridTimer: false,

    definitionProperty: 'gridDefinition',

    scopeProperty: '',

    useParent: false,

    gridHeight: {
      height: '130px'
    },
    uuid: uuid2.newuuid(),

    isAccessbilityEnabled: false,
    isInitted: false,

    paginationText: '',
    selectedRowPosition: {},

    init: function() {

      if (!ctrl.isInitted) {
        if ($attrs && $attrs.definition) {
          ctrl.definitionProperty = $attrs.definition;
        }

        if ($attrs && $attrs.scopeProperty) {
          ctrl.scopeProperty = $attrs.scopeProperty;
        }

        if ($attrs && $attrs.useParent) {
          ctrl.useParent = $attrs.useParent === 'true';
        }

        ctrl.isAccessbilityEnabled = ctrl.getDefinition().isAccessbilityEnabled;

        if (ctrl.isAccessbilityEnabled) {
          ctrl.addAccessibleGridHandlers();
        } else {
          ctrl.initAGGrid();
          ctrl.addAGGridHandlers();
        }

        ctrl.isInitted = true;
        ctrl.selectedRowPosition[ctrl.uuid] = {};
        $scope.$on('DataGrid::ResetCaret', function(e, data) {
          ctrl.selectedRowPosition[ctrl.uuid] = {};
        });
      }
    },

    addAccessibleGridHandlers: function() {
      var resizeHandler = function() {
        if( ctrl.resizeGridTimer ) {
          $timeout.cancel(ctrl.resizeGridTimer);
        }
        ctrl.resizeGridTimer = $timeout(function() {
          ctrl.resizeGrid();
        }, 250);
      };

      $scope.$on('DataGrid::ResizeGrid', function(e, data) {
        var gridDefinition = ctrl.getDefinition();

        if (gridDefinition.options.gridName === data.name) {

          if (data.totalItems !== undefined && data.totalItems !== null) {
            gridDefinition.options.totalItems = data.totalItems;
            gridDefinition.gridApi.grid.options.totalItems = data.totalItems;
          }
          gridDefinition.updateGridHeight(data.datasetLength || 0);
          gridDefinition.expandGroupedRows();
          $(window).trigger('resize');
        }
      });

      $scope.$on('DataGrid::Search', function(e, data) {
        var gridDefinition = ctrl.getDefinition();

        if (gridDefinition.options.gridName === data.name) {
          $scope.$emit('DataGrid::UserPreferencesLoaded', {viewId: gridDefinition.viewId, gridName: gridDefinition.options.gridName});
        }
      });

      $scope.$on('DataGrid::SetSelection', function(e, selected) {
        var gridDefinition = ctrl.getDefinition();

        gridDefinition.selectRows(selected);

        if (gridDefinition.options.enableUnselect) {
          ctrl.setUnselectButton();
        }
      });

      $scope.$on('DataGrid::selectRow', ctrl.selectRow);
      $scope.$on('DataGrid::unselectRow', ctrl.unselectRow);
      $scope.$on('DataGrid::clearSelection', ctrl.clearSelection);

      $scope.$on('DataGrid::CellNavCellClicked', ctrl.onCellNavEvent);
      $scope.$on('DataGrid::UpdateCursor', ctrl.onUpdateCursor);

      $(window).on('resize', resizeHandler);

      $scope.$on('$destroy', function() {
        $(window).off('resize', resizeHandler);
        $timeout.cancel(ctrl.resizeGridTimer);
      });
    },

    initAGGrid: function() {
      ctrl.getGridData();
    },

    getGridData: function() {
      ctrl.getDefinition().options.rowData = ctrl.getParsedData();
      $timeout(function() {
        $(window).trigger('resize');
      }, 0);
    },

    getParsedData: function() {
      var gridDefinition = ctrl.getDefinition();
      var func;
      var r = [];

      if (gridDefinition && gridDefinition.options && gridDefinition.options.data) {
        func = $parse(gridDefinition.options.data);
        r = func($scope) || [];
      }

      return r;
    },

    addAGGridHandlers: function() {
      $scope.$on('DataGrid::RefreshGrid', function(e, data) {
        ctrl.refreshGrid();
      });

      $scope.$on('DataGrid::ResizeGrid', function(e, data) {
        var count;
        var gridDefinition = ctrl.getDefinition();
        var resizeHandler = function() {
          if( ctrl.resizeAGGridTimer ) {
            $timeout.cancel(ctrl.resizeAGGridTimer);
          }
          ctrl.resizeAGGridTimer = $timeout(function() {
            ctrl.getDefinition().options.api.sizeColumnsToFit();
          }, 250);
        },
        clickHandler = function(e) {
          var target = $(e.target).closest('.fa-bars, .dataGrid-menu');

          ctrl.setAGSelectedRowPosition(e);
          if (!target.length && ctrl.showGridMenu) {
            ctrl.showGridMenu = false;
            $scope.$apply();
          }
        };

        if (gridDefinition.options.gridName === data.name) {
          count = (data && data.totalItems !== undefined && data.totalItems !== null) ? data.totalItems : gridDefinition.options.totalItems || 0;
          gridDefinition.options.totalItems = count;
          if (gridDefinition.options.enableServerSideSorting || gridDefinition.options.rowModelType === 'pagination') {
            if (ctrl.deferred) {
              ctrl.deferred.resolve({
                list: count ? ctrl.getParsedData() : [],
                count: count
              });
            }else {
              ctrl.setDataSource();
            }
          } else {
            ctrl.setGridData();
          }
          ctrl.resizeAGGrid(data.datasetLength || 0);
        }

        $(window).on('resize', resizeHandler);

        $(document).on('click', clickHandler);

        $scope.$on('$destroy', function() {
          $(window).off('resize', resizeHandler);
          $(document).off('click', clickHandler);
          $timeout.cancel(ctrl.resizeAGGridTimer);
        });

      });

      $scope.$on('DataGrid::Search', function(e, data) {
        var gridDefinition = ctrl.getDefinition();
        if (gridDefinition.options.gridName === data.name) {
          if (gridDefinition.options.totalItems) {
            delete gridDefinition.options.totalItems;
          }
          ctrl.setDataSource();
        }
      });

      $scope.$on('DataGrid::GridOptionsLoaded', function(e, data) {
        if (ctrl.getDefinition().options.gridName === data.name) {
          ctrl.changeColumnVisibility();
          ctrl.setDataSource();
        }
      });

      $('.data-ag-grid').on('click', ctrl.onPaginate);

      $scope.$on('$destroy', function() {
        $('.data-ag-grid').off('click', ctrl.onPaginate);
      });
    },

    setGridData: function() {
      var gridDefinition = ctrl.getDefinition();
      gridDefinition.options.api.setRowData(ctrl.getParsedData());
      gridDefinition.options.api.refreshView();
      gridDefinition.options.api.sizeColumnsToFit();
    },

    refreshGrid: function(){
      var gridDefinition = ctrl.getDefinition();

      gridDefinition.options.api.refreshView();
    },

    changeColumnVisibility: function() {
      var gridDefinition = ctrl.getDefinition();

      if (gridDefinition.options.api) {
        gridDefinition.options.api.setColumnDefs(gridDefinition.options.columnDefs);
      }
    },

    setDataSource: function() {
      var gridDefinition = ctrl.getDefinition();
      var pageNumber = gridDefinition.options.pageNumber && gridDefinition.options.pageNumber > 0 ? gridDefinition.options.pageNumber - 1 : 0;
      var dataSource = {
        rowCount: parseInt(gridDefinition.options.totalItems, 10),
        pageNumber: parseInt(pageNumber, 10),
        pageSize: parseInt(gridDefinition.options.pageSize, 10), // changing to number, as scope keeps it as a string
        getRows: function (params) {
          ctrl.getDataForGrid(params);
          if (gridDefinition.options.api.paginationController.datasource.pageNumber) {
            //reset the pageNumber now since we've already initialized the datasource.
            gridDefinition.options.api.paginationController.datasource.pageNumber = 0;
          }
        }
      };

      if (gridDefinition.options.api) {
        gridDefinition.options.api.setDatasource(dataSource);
      }

    },

    getDataForGrid: function(params) {
      var success;
      var data;
      var gridDefinition = ctrl.getDefinition();
      var currentPage = gridDefinition.options.api.paginationController.currentPage+ 1;
      var currentSortModel = params.sortModel && params.sortModel.length > 0 ? params.sortModel[0] : false;

      var gridState = {
        page: currentPage,
        pageSize: gridDefinition.options.pageSize,
        sortField: currentSortModel.colId || gridDefinition.sortField,
        sortDirection: currentSortModel.sort || gridDefinition.sortDirection
      };

      if (gridDefinition.options.pageSize) {
        gridDefinition.pageSize = gridDefinition.options.pageSize;
      }
      if (currentSortModel && currentSortModel.colId) {
        gridDefinition.sortField = currentSortModel.colId;
      }
      if (currentSortModel && currentSortModel.sort) {
        gridDefinition.sortDirection = currentSortModel.sort;
      }
      gridDefinition.updateUserPreferences();

      success = function(data) {
        var lastRow;
        var rowsThisPage = data.list || [];
        var count = data.count || 0;
        var gridDefinition = ctrl.getDefinition();

        ctrl.deferred = false;

        lastRow = parseInt(count, 10);

        if (rowsThisPage.length) {
          gridDefinition.options.api.setHeaderHeight(30);
        } else {
          gridDefinition.options.api.setHeaderHeight(0);
        }

        params.successCallback(rowsThisPage,lastRow );

        gridDefinition.options.api.sizeColumnsToFit();

        $timeout(function() {
          ctrl.setPaginationText();
        }, 0);
      };

      if (gridDefinition.options.enableServerSideSorting) {
        ctrl.getAsyncData(gridState).then(success, function(){
          //do nothing
        });
      } else {
        data = ctrl.getParsedData();
        success( {
          list: data,
          count: data.length || 0
        });
      }
    },

    getAsyncData: function(gridState) {
      var deferred = $q.defer();
      var gridDefinition = ctrl.getDefinition();

      ctrl.deferred = deferred;

      if (gridDefinition.agSortChanged) {
        gridDefinition.agSortChanged = false;
        if ( (gridDefinition.options.appScopeProvider) && (typeof gridDefinition.options.appScopeProvider.onDataGridSortChange === 'function') ) {
          gridDefinition.options.appScopeProvider.onDataGridSortChange(null,
            [{
              field: gridState.sortField,
              sort: {
                direction: gridState.sortDirection
              }
            }],
            gridState.page
          );
        }
      } else {
        if ( (gridDefinition.options.appScopeProvider) && (typeof gridDefinition.options.appScopeProvider.onDataGridPaginate === 'function') ) {
          gridDefinition.options.appScopeProvider.onDataGridPaginate(gridState.page, gridState.pageSize, gridState.sortField, gridState.sortDirection);
        }
      }

      return deferred.promise;
    },

    onPaginate: function(e) {
      if (
        $(e.target).closest('#btNext') ||
        $(e.target).closest('#btLast') ||
        $(e.target).closest('#btFirst') ||
        $(e.target).closest('#btPrevious')
      ) {
        $timeout(function() {
          ctrl.setPaginationText();
        }, 10);
      }

    },

    getNextPage: function() {
      //next tick
      $timeout(function () {
        $('#btNext').click();
        //next tick
        $timeout(function () {
          ctrl.setPaginationText();
        }, 0);
      }, 0);
    },

    getPreviousPage: function() {
      //next tick
      $timeout(function () {
        $('#btPrevious').click();
        //next tick
        $timeout(function(){
          ctrl.setPaginationText();
        }, 0);
      }, 0);
    },

    hasNext: function() {
      var gridDefinition = ctrl.getDefinition();
      var current = gridDefinition.options.api ? gridDefinition.options.api.paginationController.lbCurrent.innerHTML : 0;
      var last = gridDefinition.options.api ? gridDefinition.options.api.paginationController.totalPages : 0;

      return (current < last);
    },

    hasPrevious: function() {
      var gridDefinition = ctrl.getDefinition();
      var current = gridDefinition.options.api ? gridDefinition.options.api.paginationController.lbCurrent.innerHTML : 0;

      return (current > 1);
    },

    setPaginationText: function() {
      var gridDefinition = ctrl.getDefinition();
      var current = gridDefinition.options.api ? gridDefinition.options.api.paginationController.lbCurrent.innerHTML : 0;
      var last = gridDefinition.options.api.paginationController.totalPages;

      if (!isNaN(current) && !isNaN(last)) {
        ctrl.paginationText = current + ' of ' + last;
      }
    },

    showHideColumns: function(column) {
      var gridDefinition = ctrl.getDefinition();
      column.hide = !column.hide;
      column.visible = !column.hide;
      gridDefinition.options.columnApi.setColumnVisible(column.field, !column.hide);
      gridDefinition.options.api.sizeColumnsToFit();
      gridDefinition.updateUserPreferences();
    },

    onCellNavEvent: function (evt, data) {
      var gridApi = ctrl.getDefinition().gridApi, rowCol = data.rowCol;
      if (gridApi.grid.options.enableRowSelection && !rowCol.col.colDef.onCellNavClick && rowCol.col.field !== 'selectionRowHeaderCol') {
        if (rowCol.row.isSelected && !gridApi.grid.options.noUnselect) {
          gridApi.selection.unSelectRow(rowCol.row.entity);
        }else {
          gridApi.selection.selectRow(rowCol.row.entity);
          if (ctrl.getDefinition().options.enableUnselect) {
            ctrl.setUnselectButton();
          }
        }
      }
    },

    onUpdateCursor: function(e, data) {
      ctrl.selectedRowPosition[ctrl.uuid] = data.position;
    },

    getDefinition: function() {
      var r = $scope[ctrl.definitionProperty];
      if (ctrl.scopeProperty) {
        if (ctrl.useParent) {
          r = $scope.$parent[ctrl.scopeProperty][ctrl.definitionProperty];
        } else {
          r = $scope[ctrl.scopeProperty][ctrl.definitionProperty];
        }
      }
      return r;
    },

    resizeGrid: function() {
      var gridDefinition = ctrl.getDefinition();
      if (ctrl.isLoaded()) {
        gridDefinition.gridApi.core.handleWindowResize();
        gridDefinition.gridApi.core.notifyDataChange('all');
      }
    },

    resizeAGGrid: function(numRows) {
      ctrl.updateAGGridHeight(numRows);
      $timeout(function() {
        $(window).trigger('resize');
      }, 200);
    },

    updateAGGridHeight: function(numRows) {
      var r;
      var gridDefinition = ctrl.getDefinition();
      var adjustment = 25;

      numRows = numRows || 10;

      r = (numRows * gridDefinition.options.rowHeight + 30 + 27 + adjustment);

      r = r + "px";

      ctrl.gridHeight.height = r;
    },

    setAGSelectedRowPosition: function(e) {
      var mid = 0;
      var yOffset = 5;
      var target = $(e.target);
      var gridDefinition = ctrl.getDefinition();
      var root = target.closest('.dataGrid-ag-grid');
      var uuid = root.attr('data-uuid') || ctrl.uuid;
      var row = target.closest('.ag-row.ag-row-selected');

      if (row.length) {
        var header = row.closest('.ag-root').find('.ag-header').first().height();
        var wrapper = row.closest('.ag-body-viewport-wrapper').position().top;

        if (!root.attr('data-uuid')) {
          root.attr('data-uuid', uuid);
        }

        $timeout(function(){

          mid = row.first().position().top + wrapper + header + (Math.floor(gridDefinition.options.rowHeight / 2) - yOffset);
          if (row.length) {
            ctrl.selectedRowPosition[ctrl.uuid] = {
              display: 'block',
              top: mid + 'px',
              left: '-6px'
            };
          }
        }, 10);
      }
    },

    isLoaded: function() {
      return (ctrl.getDefinition() && ctrl.getDefinition().isLoaded);
    },

    hasItems: function() {
      var r = false;
      r = (ctrl.getDefinition() && ctrl.getDefinition().options.totalItems);
      return r;
    },

    hasPreviousPage: function() {
      return (ctrl.isLoaded() && (ctrl.getDefinition().gridApi && ctrl.getDefinition().gridApi.pagination.getPage() > 1));
    },

    hasNextPage: function() {
      return (ctrl.isLoaded() && ctrl.getDefinition().gridApi && (ctrl.getDefinition().gridApi.pagination.getPage() < ctrl.getDefinition().gridApi.pagination.getTotalPages()));
    },

    showMenu: function() {
      var gridDefinition = ctrl.getDefinition();
      return gridDefinition.options.enableGridMenu && ctrl.hasItems();
    },

    selectRow: function (event, data) {
      var gridDefinition = ctrl.getDefinition();

      if (data && data.row) {
        gridDefinition.selectRow(data.row);
      }
    },

    unselectRow: function (event, data) {
      var gridDefinition = ctrl.getDefinition();

      if (data && data.row) {
        gridDefinition.unselectRow(data.row);
      }
    },

    clearSelection: function() {
      var gridDefinition = ctrl.getDefinition();

      ctrl.selectedRowPosition[ctrl.uuid] = {
        display: 'none',
        top: '0px',
        left: '0px'
      };

      gridDefinition.clearSelection();

      $scope.$emit('DataGrid::ClearSelection');
    },

    removeSelection: function() {
      var gridDefinition = ctrl.getDefinition();

      ctrl.selectedRowPosition[ctrl.uuid] = {
        display: 'none',
        top: '0px',
        left: '0px'
      };

      gridDefinition.clearSelection();

      $scope.$emit('DataGrid::RemoveSelection');
    },

    setUnselectButton: function() {
      var test = $('<a/>', {
        text: 'unselect',
        click: function () {
          ctrl.removeSelection();
        },
        tabindex: 0,
        class: 'ui-grid-footer-info-unselect'
      });

      if (!$('.ui-grid-footer-info-unselect').length) {
        $timeout(function(){
          $('.ui-grid-footer-info span:nth-child(2)').append(test);
        });
      }
    }
  };

  $scope.dataGrid = ctrl;
  ctrl.init();

}]);
